import { useState } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Calendar, ExternalLink, Download } from "lucide-react";
import SkylineHero from "@/components/SkylineHero";
import { Button } from "@/components/ui/button";

const NewsPress = () => {
  const [activeTab, setActiveTab] = useState("news");

  const newsItems = [
    {
      title: "Brassbell Hospitality Group Launches \"Fanaya Hotel\" in Jeddah, Introducing a New Art-Driven Lifestyle Destination in Saudi Arabia",
      excerpt: "Brassbell officially enters the Saudi Arabian market with Fanaya Hotel in Jeddah, marking a significant milestone in the company's expansion strategy aligned with Vision 2030.",
      content: "Brassbell Hospitality Group has officially entered the Saudi Arabian market with the launch of Fanaya Hotel in Jeddah, the first property of the brand worldwide and the cornerstone of a broader multi-phase expansion strategy across the Kingdom. The debut of Fanaya marks a significant milestone for Brassbell, reflecting its commitment to bringing design-led, culturally inspired hospitality concepts to Saudi Arabia at a time when the Kingdom's tourism and hospitality sectors are evolving rapidly in line with Vision 2030. Anchored in a philosophy that merges art, craft, and community, Fanaya introduces a contemporary interpretation of lifestyle hospitality, drawing inspiration from the Arabic roots of fan, fanni, and fannaya. The hotel blends local heritage with modern design principles, creating a refined, immersive environment where creativity and cultural expression influence every element of the guest journey.",
      date: "2025-11-18",
      image: "https://invest-gate.me/wp-content/uploads/2025/11/WhatsApp-Image-2025-11-18-at-11.06.30_6d4a74ec-750x500.jpg",
      author: "Invest-Gate",
      url: "https://invest-gate.me/news/brassbell-hospitality-group-launches-fanaya-hotel-in-jeddah-introducing-a-new-art-driven-lifestyle-destination-in-saudi-arabia/"
    },
    {
      title: "Egypt's Brassbell Hospitality Group Sets Foot in Saudi with SAR 120 mn Fanaya Hotel in Jeddah",
      excerpt: "Fanaya features 51 suites that combine local heritage with contemporary design, all built to international standards with a SAR 120 million investment.",
      content: "Egypt-based Brassbell Hospitality Group launched Fanaya Hotel in Jeddah with a SAR 120 mn investment, marking the group's first venture outside of Egypt and its first in the Kingdom. The project features 51 suites, including 39 executive suites, three signature suites, eight superior suites, and an exclusive royal suite. It also features The Collectors' Lounge, The Atelier, The Supper Club, The Courtyard Café, and The Rooftop. Fanaya targets culturally-engaged visitors and young and mid-career professionals. Brassbell is positioning the Kingdom as its primary expansion focus over the next five years. Following its debut in Jeddah, the group is in advanced discussions to open two new Fanaya properties in Riyadh.",
      date: "2025-11-18",
      image: "https://ent.news/2025/11/1453.jpg",
      author: "Enterprise",
      url: "https://enterprise.news/ksa/en/news/story/2152c45b-69f8-4a80-a7ae-9c6be2293f47/egypt%e2%80%99s-brassbell-hospitality-group-sets-foot-in-saudi-with-sar-120-mn-fanaya-hotel-in-jeddah"
    },
    {
      title: "Brassbell Hospitality Group Debuts Fanaya Hotel in Jeddah",
      excerpt: "Brassbell launches its Fanaya Hotel in Jeddah as Saudi hospitality shifts toward design-led and culturally driven destinations, with USD 40 million investment.",
      content: "Brassbell Hospitality Group, an Egypt-based hospitality and lifestyle developer-operator, has made its Saudi Arabia debut with the launch of Fanaya Hotel in Jeddah. The project's total investment value is around USD 40 million (SAR 120M) and is the first property under the company's new art-centered lifestyle brand. The hotel arrives at a time when Saudi Arabia's hospitality sector is evolving rapidly, with a growing demand for design-led, culturally rooted, and community-focused destinations. The new brand combines contemporary design with Saudi cultural identity, laying the groundwork for a nationwide expansion strategy. Brassbell is already negotiating new Fanaya locations in Riyadh as it builds a long-term presence in the Kingdom.",
      date: "2025-11-18",
      image: "https://waya.media/wp-content/uploads/sites/3/2025/11/Brassbell-Hospitality-Group-Expands-into-Saudi-Arabia-with-Launch-of-Fanaya-Hotel-in-Jeddah.png",
      author: "WAYA Media",
      url: "https://waya.media/brassbell-hospitality-group-debuts-fanaya-hotel-in-jeddah/"
    },
    {
      title: "Tatweer Misr launches first hospitality brand 'Bay House' in partnership with Brassbell",
      excerpt: "Strategic partnership brings premium hospitality services to D-Bay and Fouka Bay on Egypt's North Coast.",
      content: "Egyptian real estate developer Tatweer Misr has announced the official launch of its first dedicated hospitality brand, Bay House, through a strategic partnership with Brassbell Hospitality Group—a leader in smart, tech-enabled hospitality solutions. This milestone reflects Tatweer Misr's ongoing commitment to adding value and delivering elevated, integrated experiences across its flagship developments. Bay House will debut within Tatweer Misr's prominent North Coast projects, D-Bay and Fouka Bay, bringing a premium hospitality offering to two of Egypt's most sought-after coastal destinations.",
      date: "2025-08-03",
      image: "/lovable-uploads/bay-house-daily-news-egypt.jpg",
      author: "Daily News Egypt",
      url: "https://www.dailynewsegypt.com/2025/08/03/tatweer-misr-launches-first-hospitality-brand-bay-house-in-partnership-with-brassbell/"
    },
    {
      title: "Brassbell Hospitality Group and Belmazad Sign a Strategic Partnership to Transform Auctioned Real Estate into Hospitality Investments",
      excerpt: "Egypt's leading serviced apartment operator partners with the country's premier digital auction marketplace to convert underutilized real estate assets into high-value hospitality investments.",
      content: "Brassbell Hospitality Group (BHG), Egypt's leading serviced apartment operator, has signed a strategic partnership with Belmazad, the country's premier digital auction marketplace, to convert auctioned and underutilized real estate assets into high-value hospitality investments. The agreement creates a first-of-its-kind framework linking proptech with hospitality development, establishing a transparent pathway to unlock new value in underutilized assets while creating long-term opportunities for investors and communities.",
      date: "2025-09-14",
      image: "https://invest-gate.me/wp-content/uploads/2025/09/WhatsApp-Image-2025-09-14-at-11.44.07-AM-750x500.jpeg",
      author: "Mustafa Almahdy",
      url: "https://invest-gate.me/news/brassbell-hospitality-group-and-belmazad-sign-a-strategic-partnership-to-transform-auctioned-real-estate-into-hospitality-investments/"
    },
    {
      title: "Tatweer Misr launches its first hospitality brand, Bay House, in strategic collaboration with Brassbell Hospitality Group",
      excerpt: "Leading real estate developer announces Bay House brand launch in D-Bay & Fouka Bay to deliver premium hospitality across integrated urban communities.",
      content: "Tatweer Misr, a leading real estate developer in Egypt, has officially announced the launch of its first hospitality brand, Bay House, in strategic collaboration with Brassbell Hospitality Group. The introduction of Bay House highlights Tatweer Misr's dedication to meeting the evolving needs of its clients by offering innovative, lifestyle-enhancing hospitality services. The collaboration with Brassbell Hospitality group demonstrates Tatweer Misr's commitment to maintaining the highest standards of quality and excellence across all touchpoints.",
      date: "2025-08-03",
      image: "/lovable-uploads/bay-house-tatweer-misr.jpg",
      author: "Zawya Press Release",
      url: "https://www.zawya.com/en/press-release/companies-news/tatweer-misr-launches-its-first-hospitality-brand-bay-house-in-strategic-collaboration-with-brassbell-hospitality-group-g1eaholq"
    },
    {
      title: "Brassbell-Belmazad Partner to Transform Auctioned Real Estate into Hospitality Assets",
      excerpt: "Strategic partnership between Brassbell Hospitality Group and Belmazad creates innovative framework to convert auction properties into ready-to-operate hospitality investments.",
      content: "Brassbell Hospitality Group and Belmazad have announced a groundbreaking partnership to transform auctioned real estate into hospitality investments. This collaboration combines Belmazad's auction platform with BHG's hospitality expertise to turn auctioned properties into ready-to-operate investment opportunities, helping unlock hidden value and advancing Egypt's vision to maximize underutilized assets.",
      date: "2025-09-14",
      image: "https://invest-gate.me/wp-content/uploads/2025/09/WhatsApp-Image-2025-09-14-at-11.44.07-AM-750x500.jpeg",
      author: "Daily News Egypt",
      url: "https://www.dailynewsegypt.com/2025/09/14/brassbell-belmazad-partner-to-transform-auctioned-real-estate-into-hospitality-assets/"
    },
    {
      title: "Tatweer Misr launches first hospitality brand 'Bay House' in partnership with Brassbell",
      excerpt: "Egyptian real estate developer announces dedicated hospitality brand debut in D-Bay and Fouka Bay coastal destinations.",
      content: "Egyptian real estate developer Tatweer Misr has announced the official launch of its first dedicated hospitality brand, Bay House, through a strategic partnership with Brassbell Hospitality Group—a leader in smart, tech-enabled hospitality solutions. This milestone reflects Tatweer Misr's ongoing commitment to adding value and delivering elevated, integrated experiences across its flagship developments. Bay House will debut within Tatweer Misr's prominent North Coast projects, bringing a premium hospitality offering to Egypt's most sought-after coastal destinations.",
      date: "2025-08-04",
      image: "/lovable-uploads/bay-house-hotel-report.jpg",
      author: "Hotel Report",
      url: "https://hotel.report/novosti/tatweer-misr-launches-first-hospitality-brand-bay-house-in-partnership-with-brassbell"
    },
    {
      title: "Tatweer Misr Launches Its First Hospitality Brand, \"Bay House,\" in Strategic Collaboration with Brassbell Hospitality Group",
      excerpt: "New hospitality brand Bay House launched in D-Bay & Fouka Bay to deliver premium integrated living experiences across Egypt's North Coast.",
      content: "Tatweer Misr, a leading real estate developer in Egypt, has officially announced the launch of its first hospitality brand, Bay House, in strategic collaboration with Brassbell Hospitality Group. This launch reflects Tatweer Misr's continued commitment to delivering added value and an integrated, elevated experience across its developments. The collaboration aims to redefine standards in hospitality and integrated living along Egypt's North Coast by combining Tatweer Misr's visionary developments with Brassbell's hospitality expertise.",
      date: "2025-08-03",
      image: "/lovable-uploads/bay-house-tatweer-misr.jpg",
      author: "Wael Hossam El-Din",
      url: "https://invest-gate.me/news/tatweer-misr-launches-its-first-hospitality-brand-bay-house-in-strategic-collaboration-with-brassbell-hospitality-group/"
    }
  ];

  const pressItems = [
    {
      title: "Brassbell Hospitality Group and Tatweer Misr Partnership Announcement",
      excerpt: "Strategic partnership ceremony featuring key executives from both companies, announcing the launch of Bay House hospitality brand.",
      content: "A historic partnership ceremony between Brassbell Hospitality Group and Tatweer Misr, marking the official launch of the Bay House hospitality brand. This strategic collaboration combines Tatweer Misr's visionary developments with Brassbell's hospitality expertise to deliver premium integrated living experiences across Egypt's North Coast.",
      date: "2025-08-03",
      image: "/lovable-uploads/6d37aa27-9811-4a76-9592-3e412b5e970c.png",
      publication: "Corporate Press Release",
      downloadUrl: "/lovable-uploads/brassbell-tatweer-partnership-press-release.pdf"
    }
  ];

  const blogItems: any[] = [];
  const renderArticles = (articles: typeof newsItems | typeof pressItems | typeof blogItems, type: 'news' | 'press' | 'blog') => (
    <div className="space-y-8 sm:space-y-12 md:space-y-16 lg:space-y-20 xl:space-y-24">
      {articles.map((article, index) => (
        <article key={index} 
          className={`relative ${
            index % 2 === 0 
              ? 'md:flex md:items-center' 
              : 'md:flex md:items-center md:flex-row-reverse'
          }`}
        >
          {/* Decorative Elements */}
          <div className={`absolute -z-10 ${
            index % 2 === 0 
              ? '-left-2 sm:-left-3 md:-left-4 top-4 sm:top-6 md:top-8 w-16 h-16 sm:w-24 sm:h-24 md:w-32 md:h-32 bg-primary/5 rounded-full blur-2xl' 
              : '-right-2 sm:-right-3 md:-right-4 top-4 sm:top-6 md:top-8 w-16 h-16 sm:w-24 sm:h-24 md:w-32 md:h-32 bg-secondary/5 rounded-full blur-2xl'
          }`}></div>
          
          {/* Image Section */}
          <div className={`md:w-5/12 ${index % 2 === 0 ? 'md:pr-8 lg:pr-12 xl:pr-16' : 'md:pl-8 lg:pl-12 xl:pl-16'} mb-4 sm:mb-6 md:mb-0`}>
            <div className="relative group">
              <div className="aspect-[4/3] rounded-xl sm:rounded-2xl overflow-hidden bg-muted shadow-xl cursor-pointer" 
                onClick={() => {
                  if (type === 'blog') {
                    window.location.href = `/blog/${blogItems.findIndex(item => item.title === article.title) + 1}`;
                  } else if ('url' in article && article.url) {
                    window.open(article.url, '_blank', 'noopener,noreferrer');
                  }
                }}>
                <img
                  src={article.image}
                  alt={article.title}
                  width="371"
                  height="248"
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className={`absolute -bottom-2 sm:-bottom-3 md:-bottom-4 ${
                index % 2 === 0 ? '-right-2 sm:-right-3 md:-right-4' : '-left-2 sm:-left-3 md:-left-4'
              } w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 bg-gradient-to-br from-primary/20 to-secondary/20 rounded-xl sm:rounded-2xl backdrop-blur-sm border border-white/10`}></div>
            </div>
          </div>

          {/* Content Section */}
          <div className={`md:w-7/12 space-y-3 sm:space-y-4 md:space-y-6 ${
            index % 2 === 0 ? 'md:text-left' : 'md:text-right'
          }`}>
            {/* Meta Information */}
            <div className={`flex items-center gap-3 sm:gap-4 md:gap-6 ${
              index % 2 === 0 ? 'justify-start' : 'md:justify-end'
            } flex-wrap`}>
              <div className="flex items-center text-xs sm:text-sm text-muted-foreground">
                <Calendar className="h-3 w-3 sm:h-4 sm:w-4 mr-1.5 sm:mr-2" />
                {new Date(article.date).toLocaleDateString('en-US', { 
                  year: 'numeric', 
                  month: 'long', 
                  day: 'numeric' 
                })}
              </div>
              {type === 'press' && 'publication' in article && (
                <div className="flex items-center gap-2">
                  <div className="w-1 h-1 bg-primary rounded-full"></div>
                  <span className="text-xs sm:text-sm text-primary font-medium">
                    {article.publication}
                  </span>
                </div>
              )}
              {type === 'blog' && 'category' in article && (
                <div className="flex items-center gap-2">
                  <div className="w-1 h-1 bg-secondary rounded-full"></div>
                  <span className="text-xs sm:text-sm text-secondary font-medium">
                    {article.category}
                  </span>
                </div>
              )}
              {type === 'blog' && 'readTime' in article && (
                <div className="flex items-center gap-2">
                  <div className="w-1 h-1 bg-muted-foreground rounded-full"></div>
                  <span className="text-xs sm:text-sm text-muted-foreground">
                    {article.readTime}
                  </span>
                </div>
              )}
              {type === 'news' && 'author' in article && (
                <div className="flex items-center gap-2">
                  <div className="w-1 h-1 bg-secondary rounded-full"></div>
                  <span className="text-xs sm:text-sm text-secondary-foreground">
                    {article.author}
                  </span>
                </div>
              )}
            </div>

            {/* Title with Creative Typography */}
            <div className="space-y-2 sm:space-y-3 md:space-y-4">
              <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-light text-foreground leading-tight cursor-pointer hover:text-primary transition-colors duration-300"
                onClick={() => {
                  if (type === 'blog') {
                    window.location.href = `/blog/${blogItems.findIndex(item => item.title === article.title) + 1}`;
                  } else if ('url' in article && article.url) {
                    window.open(article.url, '_blank', 'noopener,noreferrer');
                  }
                }}>
                {article.title}
              </h2>
              <div className={`w-8 sm:w-12 md:w-16 h-px bg-gradient-to-r ${
                index % 2 === 0 
                  ? 'from-primary to-transparent' 
                  : 'from-transparent to-primary md:ml-auto'
              }`}></div>
            </div>

            {/* Content */}
            <div className="space-y-2 sm:space-y-3 md:space-y-4">
              <p className="text-sm sm:text-base md:text-lg text-muted-foreground leading-relaxed">
                {article.excerpt}
              </p>
              <p className="text-xs sm:text-sm md:text-base text-foreground leading-relaxed opacity-80">
                {article.content}
              </p>
            </div>

            {/* CTA Button */}
            <div className={`pt-2 sm:pt-3 md:pt-4 ${index % 2 === 0 ? '' : 'md:flex md:justify-end'}`}>
              {type === 'blog' ? (
                <a href={`/blog/${blogItems.findIndex(item => item.title === article.title) + 1}`}>
                  <Button
                    variant="outline" 
                    size="sm"
                    className={`inline-flex items-center gap-2 px-4 sm:px-6 md:px-8 py-2 sm:py-2.5 md:py-3 text-xs sm:text-sm md:text-base transition-all duration-300 hover:scale-105 ${
                      index % 2 === 0 
                        ? 'hover:translate-x-1' 
                        : 'hover:-translate-x-1'
                    }`}
                  >
                    Read Full Article
                    <ExternalLink className="h-3 w-3 sm:h-4 sm:w-4" />
                  </Button>
                </a>
              ) : 'url' in article && article.url ? (
                <a href={article.url} target="_blank" rel="noopener noreferrer">
                  <Button 
                    variant="outline" 
                    size="sm"
                    className={`inline-flex items-center gap-2 px-4 sm:px-6 md:px-8 py-2 sm:py-2.5 md:py-3 text-xs sm:text-sm md:text-base transition-all duration-300 hover:scale-105 ${
                      index % 2 === 0 
                        ? 'hover:translate-x-1' 
                        : 'hover:-translate-x-1'
                    }`}
                  >
                    Read Full Article
                    <ExternalLink className="h-3 w-3 sm:h-4 sm:w-4" />
                  </Button>
                </a>
              ) : type === 'press' && 'downloadUrl' in article && article.downloadUrl ? (
                <a href={article.downloadUrl} download>
                  <Button 
                    variant="outline" 
                    size="sm"
                    className={`inline-flex items-center gap-2 px-4 sm:px-6 md:px-8 py-2 sm:py-2.5 md:py-3 text-xs sm:text-sm md:text-base transition-all duration-300 hover:scale-105 ${
                      index % 2 === 0 
                        ? 'hover:translate-x-1' 
                        : 'hover:-translate-x-1'
                    }`}
                  >
                    Download Press Release
                    <Download className="h-3 w-3 sm:h-4 sm:w-4" />
                  </Button>
                </a>
              ) : (
                <Button 
                  variant="outline" 
                  size="sm"
                  className={`inline-flex items-center gap-2 px-4 sm:px-6 md:px-8 py-2 sm:py-2.5 md:py-3 text-xs sm:text-sm md:text-base transition-all duration-300 hover:scale-105 ${
                    index % 2 === 0 
                      ? 'hover:translate-x-1' 
                      : 'hover:-translate-x-1'
                  }`}
                >
                  Read Full Article
                  <ExternalLink className="h-3 w-3 sm:h-4 sm:w-4" />
                </Button>
              )}
            </div>
          </div>
        </article>
      ))}
    </div>
  );

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      {/* Back button */}
      <div className="absolute top-4 left-4 sm:top-6 sm:left-6 md:top-8 md:left-8 z-20">
        <a 
          href="/"
          className="flex items-center text-muted-foreground hover:text-foreground transition-all duration-300 hover-scale group bg-background/80 backdrop-blur-sm rounded-full px-3 py-2 border border-border/50"
        >
          <svg className="mr-1 sm:mr-2 transition-transform duration-300 group-hover:-translate-x-1" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="m12 19-7-7 7-7"/>
            <path d="M19 12H5"/>
          </svg>
          <span className="text-xs sm:text-sm">Back to Home</span>
        </a>
      </div>
      
      <main className="pt-16 sm:pt-20">
        {/* Asymmetric Hero Section */}
        <section className="relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-secondary/5"></div>
          <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-muted/20 to-transparent"></div>
          {/* Skyline drawing animation — matches hotels hero */}
          <SkylineHero className="opacity-20" />
          
          <div className="relative container mx-auto px-4 sm:px-6 py-8 sm:py-12 md:py-16 lg:py-24">
            <div className="grid lg:grid-cols-12 gap-6 sm:gap-8 md:gap-10 lg:gap-12 items-center">
              <div className="lg:col-span-7">
                <div className="space-y-4 sm:space-y-6">
                  <div className="flex items-center gap-2 sm:gap-3 md:gap-4 mb-4 sm:mb-6 md:mb-8">
                    <div className="w-8 sm:w-12 md:w-16 h-px bg-gradient-to-r from-primary to-transparent"></div>
                    <span className="text-xs sm:text-sm font-medium text-primary tracking-widest uppercase">Latest Updates</span>
                  </div>
                  <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl 2xl:text-6xl font-light text-foreground leading-tight">
                    News &<br />
                    <span className="text-primary">Press</span>
                  </h1>
                  <p className="text-sm sm:text-base md:text-lg lg:text-xl text-muted-foreground max-w-2xl leading-relaxed">
                    Discover the latest developments, industry recognition, and strategic initiatives shaping the future of Brassbell Holdings
                  </p>
                </div>
              </div>
              <div className="lg:col-span-5">
                <div className="relative">
                  <div className="absolute -top-4 sm:-top-6 md:-top-8 -right-4 sm:-right-6 md:-right-8 w-16 h-16 sm:w-24 sm:h-24 md:w-32 md:h-32 bg-primary/10 rounded-full blur-xl"></div>
                  <div className="absolute -bottom-2 sm:-bottom-3 md:-bottom-4 -left-2 sm:-left-3 md:-left-4 w-12 h-12 sm:w-16 sm:h-16 md:w-24 md:h-24 bg-secondary/10 rounded-full blur-lg"></div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Creative Navigation */}
        <section className="py-4 sm:py-6 md:py-8 lg:py-12 border-b border-border/50">
          <div className="container mx-auto px-4 sm:px-6">
            <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4 sm:gap-6 md:gap-8">
                  <TabsList className="bg-transparent p-0 h-auto space-x-4 sm:space-x-6 md:space-x-8">
                    <TabsTrigger 
                      value="news" 
                      className="bg-transparent text-base sm:text-lg md:text-xl lg:text-2xl font-light px-0 py-2 sm:py-3 md:py-4 border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary rounded-none"
                    >
                      News
                    </TabsTrigger>
                    <TabsTrigger 
                      value="press" 
                      className="bg-transparent text-base sm:text-lg md:text-xl lg:text-2xl font-light px-0 py-2 sm:py-3 md:py-4 border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary rounded-none"
                    >
                      Press
                    </TabsTrigger>
                    <TabsTrigger 
                      value="blog" 
                      className="bg-transparent text-base sm:text-lg md:text-xl lg:text-2xl font-light px-0 py-2 sm:py-3 md:py-4 border-b-2 border-transparent data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:text-primary rounded-none"
                    >
                      Our Blog
                    </TabsTrigger>
                  </TabsList>
                </div>
                <div className="hidden md:flex items-center gap-4 text-sm text-muted-foreground">
                  <div className="flex items-center gap-2">
                    <div className="w-2 h-2 bg-primary rounded-full"></div>
                    <span>Live Updates</span>
                  </div>
                </div>
              </div>
            </Tabs>
          </div>
        </section>

        {/* Dynamic Content Layout */}
        <section className="py-6 sm:py-8 md:py-12 lg:py-16 xl:py-20">
          <div className="container mx-auto px-4 sm:px-6">
            <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
              <TabsContent value="news" className="mt-0">
                <div className="mb-6 sm:mb-8 md:mb-12 lg:mb-16">
                  <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
                    <div>
                      <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-light text-foreground mb-2 sm:mb-3">Latest News</h2>
                      <div className="w-12 sm:w-16 md:w-24 h-px bg-gradient-to-r from-primary to-transparent"></div>
                    </div>
                    <p className="text-muted-foreground max-w-md text-left sm:text-right text-xs sm:text-sm md:text-base">
                      Company updates, project announcements, and development milestones
                    </p>
                  </div>
                </div>
                {renderArticles(newsItems, 'news')}
              </TabsContent>
              
              <TabsContent value="press" className="mt-0">
                <div className="mb-6 sm:mb-8 md:mb-12 lg:mb-16">
                  <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
                    <div>
                      <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-light text-foreground mb-2 sm:mb-3">Press Coverage</h2>
                      <div className="w-12 sm:w-16 md:w-24 h-px bg-gradient-to-r from-primary to-transparent"></div>
                    </div>
                    <p className="text-muted-foreground max-w-md text-left sm:text-right text-xs sm:text-sm md:text-base">
                      Media coverage, industry recognition, and executive interviews
                    </p>
                  </div>
                </div>
                {renderArticles(pressItems, 'press')}
              </TabsContent>
              
              <TabsContent value="blog" className="mt-0">
                <div className="mb-6 sm:mb-8 md:mb-12 lg:mb-16">
                  <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
                    <div>
                      <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-light text-foreground mb-2 sm:mb-3">Our Blog</h2>
                      <div className="w-12 sm:w-16 md:w-24 h-px bg-gradient-to-r from-primary to-transparent"></div>
                    </div>
                    <p className="text-muted-foreground max-w-md text-left sm:text-right text-xs sm:text-sm md:text-base">
                      Industry insights, thought leadership, and expert perspectives on real estate and hospitality
                    </p>
                  </div>
                </div>
                {blogItems.length > 0 ? (
                  renderArticles(blogItems, 'blog')
                ) : (
                  <div className="flex flex-col items-center justify-center py-16 sm:py-20 md:py-24 lg:py-32">
                    <div className="text-center space-y-6">
                      <div className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 mx-auto bg-gradient-to-br from-primary/10 to-secondary/10 rounded-2xl flex items-center justify-center">
                        <svg className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0118 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" />
                        </svg>
                      </div>
                      <div className="space-y-2">
                        <h3 className="text-xl sm:text-2xl md:text-3xl font-light text-foreground">Coming Soon</h3>
                        <p className="text-sm sm:text-base md:text-lg text-muted-foreground max-w-md">
                          We're preparing insightful articles and thought leadership content. Stay tuned for expert perspectives on real estate and hospitality.
                        </p>
                      </div>
                      <div className="w-12 sm:w-16 md:w-24 h-px bg-gradient-to-r from-transparent via-primary to-transparent mx-auto"></div>
                    </div>
                  </div>
                )}
              </TabsContent>
            </Tabs>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default NewsPress;